import { usingGet, usingPost, usingDelete } from '@ocean/api'
import { UserUtils } from 'utils'
import {
  ElearningProgressUpdateDto,
  FeedbackAnswer,
  FeedbackFreeTextAnswer,
} from 'modules/activityDetails/ElearningDetails/types'

export const getElearningDetails = (elearningId: Guid, competenceId?: Guid) => {
  const params =
    competenceId === undefined || competenceId == 'undefined'
      ? `${elearningId}`
      : `${elearningId}/${competenceId}`
  return usingGet(`elearning/details/${params}`, { useProxy: true })
}
export const createElearningResult = (
  moduleId: Guid,
  language: string,
  forceNew: boolean = false
) => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  const createResultDto = {
    moduleId,
    language,
    userId,
    forceNew,
  }
  return usingPost(`Elearnings/CreateElearningResult`, createResultDto)
}

export const startElearningSession = (
  chapterId: number,
  resultId: Guid,
  takeOverElearningSession: boolean = true
) => {
  const startElearningSessionDto = {
    resultId,
    chapterId,
    takeOverElearningSession,
  }
  return usingPost(`Elearnings/StartElearningSession`, startElearningSessionDto)
}

export const updateElearningProgress = (progressUpdateDto: ElearningProgressUpdateDto) =>
  usingPost(`Elearnings/UpdateElearningProgress`, progressUpdateDto)

export const deleteElearningResult = (resultId: Guid) =>
  usingDelete(`Elearnings/DeleteElearningResult/${resultId}`)

export const getFeedbackForm = () => usingGet('Elearnings/GetFeedbackForm')

export const finalizeElearningResult = (resultId: Guid) =>
  usingPost(`Elearnings/FinalizeElearningResult`, { resultId })

export const saveFeedback = (
  resultId: Guid,
  answers: FeedbackAnswer[],
  freeTextAnswers: FeedbackFreeTextAnswer[]
) =>
  usingPost('Elearnings/SaveFeedback', {
    resultId,
    answers,
    freeTextAnswers,
  })
